import { useState } from 'react';
import Header from '../../components/Navigation/Header.jsx';
import PyschometricCamera from '../../components/KnowledgeTest/Camera.jsx';
import Instruction from '../../components/KnowledgeTest/Instruction.jsx';
import './KnowledgeTest.css';
import { useNavigate } from 'react-router-dom';

function KnowledgeTest()
{
  const [agreementSign,setAgreementSign]=useState(false);
  const navigate=useNavigate();
  const handleAgreement=(e)=>{
    setAgreementSign(e);
  
  }
    return(
    <>
      <Header/>
        {!agreementSign &&  <Instruction agreementSign={handleAgreement}/>}
        {agreementSign && navigate('/knowledgetest/questions') }
    
    </>);
}

export default KnowledgeTest;